export const translation = {
  zenit: {
    ae: {
      siteTitle: 'مكافآتك | Zenit',
      title: 'للعملاء',
      titleSpan: 'الجدد',
      promoSpan: 'الرمز الترويجي:',
      btnGet: 'احصل على',
      bkString: 'لمراهنات Zenit',
      rightString: 'جميع الحقوق محفوظة',
      rulesBtn: 'الشروط والأحكام',
      regFormTitle: `Register
        and get the bonus!`
    },
    bn: {
      siteTitle: 'আপনার বোনাস | Zenit',
      title: 'নতুন',
      titleSpan: 'গ্রাহকদের জন্য',
      promoSpan: 'প্রোমো কোড:',
      btnGet: 'পান',
      bkString: 'বুকমেকার Zenit',
      rightString: 'সর্বস্বত্ব সংরক্ষিত',
      rulesBtn: 'শর্তাবলী',
      regFormTitle: `Register
        and get the bonus!`
    },
    br: {
      siteTitle: 'Seus bônus | Zenit',
      title: 'Para novos',
      titleSpan: 'CLIENTES',
      promoSpan: 'CÓDIGO PROMOCIONAL:',
      btnGet: 'receber',
      bkString: 'Bookmaker Zenit',
      rightString: 'Todos os direitos reservados',
      rulesBtn: 'Regras',
      regFormTitle: `REGISTRE-SE
        E OBTENHA UM BÔNUS!`
    },
    de: {
      siteTitle: 'Ihre Boni | Zenit',
      title: 'FÜR NEUE',
      titleSpan: 'KUNDEN',
      promoSpan: 'PROMO CODE:',
      btnGet: 'Jetzt erhalten',
      bkString: 'Buchmacher Zenit',
      rightString: 'Alle Rechte vorbehalten',
      rulesBtn: 'Regeln',
      regFormTitle: `Register
        and get the bonus!`
    },
    en: {
      siteTitle: 'Your bonuses | Zenit',
      title: 'FOR NEW',
      titleSpan: 'CUSTOMERS',
      promoSpan: 'PROMO CODE:',
      btnGet: 'receive',
      bkString: 'Bookmaker Zenit',
      rightString: 'All rights reserved',
      rulesBtn: 'rules',
      regFormTitle: `Register
        and get the bonus!`
    },
    fr: {
      siteTitle: 'Vos bonus | Zenit',
      title: 'POUR LES NOUVEAUX',
      titleSpan: 'CLIENTS',
      promoSpan: 'CODE PROMOTIONNEL:',
      btnGet: 'OBTENIR',
      bkString: 'Bookmaker Zenit',
      rightString: 'Tous droits réservés',
      rulesBtn: 'Conditions générales',
      regFormTitle: `Register
        and get the bonus!`
    },
    ir: {
      siteTitle: 'پاداش خوش‌آمدگویی | ZENIT',
      title: 'برای مشتریان',
      titleSpan: 'جدید',
      promoSpan: 'کد هدیه:',
      btnGet: 'دریافت',
      bkString: ' بنگاه شرط‌بندی Zenit',
      rightString: 'تمامی حقوق محفوظ است',
      rulesBtn: 'قوانین',
      regFormTitle: `Register
        and get the bonus!`
    },
    kz: {
      siteTitle30: 'Бонус до 170 000 тенге | БК ZENIT',
      siteTitle35: 'Бонус до 195 000 тенге | БК ZENIT',
      title: 'новым',
      titleSpan: 'игрокам',
      promoSpan: 'промокод:',
      btnGet: 'получить',
      bkString: 'Букмекерская контора Зенит',
      rightString: 'Все права защищены',
      rulesBtn: 'правила',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    mx: {
      siteTitle: 'Sus bonificaciones | Zenit',
      title: 'PARA NUEVOS',
      titleSpan: 'CLIENTES',
      promoSpan: 'CÓDIGO PROMOCIONAL:',
      btnGet: 'OBTENER',
      bkString: 'Zenit Bookmakers',
      rightString: 'Todos los derechos reservados',
      rulesBtn: 'TÉRMINOS Y CONDICIONES',
      regFormTitle: `Register
        and get the bonus!`
    },
    ru: {
      siteTitle30: 'Бонус до 30 000 рублей | Букмекер ZENIT',
      siteTitle35: 'Бонус новичкам 35 000 руб | Ставки | ZENIT',
      siteTitleTVshows: 'До 35 000 руб новичкам | Ставки | ZENIT',
      title: 'новым',
      titleSpan: 'игрокам',
      promoSpan: 'промокод:',
      btnGet: 'получить',
      bkString: 'Букмекерская контора «Зенит»',
      rightString: 'Все права защищены',
      rulesBtn: 'правила',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    sw: {
      siteTitle: 'Bonasi zako | Zenit',
      title: `KWA AJILI YA\xA0WATEJA`,
      titleSpan: 'WAPYA',
      promoSpan: 'MSIMBO WA PROMOSHENI:',
      btnGet: 'PATA',
      bkString: 'Alamisho Zenit',
      rightString: 'Haki zote zimehifadhiwa',
      rulesBtn: `SHERIA NA\xA0MASHARTI`,
      regFormTitle: `Register
        and get the bonus!`
    },
    tr: {
      siteTitle: 'Bonuslarınız | Zenit',
      title: 'YENI',
      titleSpan: 'MÜŞTERİLER İÇİN',
      promoSpan: 'PROMOSYON KODU:',
      btnGet: 'AL',
      bkString: 'Zenit Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
      rulesBtn: 'HÜKÜM VE KOŞULLAR',
      regFormTitle: `Register
        and get the bonus!`
    },
    ua: {
      siteTitle30: 'Бонус до 11 000 гривен | БК ZENIT',
      siteTitle35: 'Бонус до 12 500 гривен | БК ZENIT',
      siteTitle: 'Твои бонусы | БК Зенит',
      title: 'новим',
      titleSpan: 'гравцям',
      promoSpan: 'промокод:',
      btnGet: 'отримати',
      bkString: 'БУКМЕКЕРСЬКА КОНТОРА ЗЕНИТ',
      rightString: 'ВСI ПРАВА ЗАХИЩЕНI',
      rulesBtn: 'правила',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    uz: {
      siteTitle: 'Bonuslaring | Zenit',
      title: 'YANGI',
      titleSpan: 'O‘YINCHILARGA',
      promoSpan: 'PROMOKOD:',
      btnGet: 'OLISH',
      bkString: 'Zenit bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
      rulesBtn: 'QOIDALAR',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | Zenit',
      title: 'DÀNH CHO',
      titleSpan: 'KHÁCH HÀNG MỚI',
      promoSpan: 'MÃ KHUYẾN MÃI:',
      btnGet: 'NHẬN',
      bkString: 'Nhà cái Zenit',
      rightString: 'Bảo lưu mọi quyền',
      rulesBtn: `Điều khoản và\xA0điều\xA0kiện`,
      regFormTitle: `Register
        and get the bonus!`
    }
  },
  zenbet: {
    ae: {
      siteTitle: 'مكافآتك | «ZENBET»',
      title: 'للعملاء',
      titleSpan: 'الجدد',
      promoSpan: 'الرمز الترويجي:',
      btnGet: 'احصل على',
      bkString: 'لمراهنات «ZENBET»',
      rightString: 'جميع الحقوق محفوظة',
      rulesBtn: 'الشروط والأحكام',
      regFormTitle: `Register
        and get the bonus!`
    },
    bn: {
      siteTitle: 'আপনার বোনাস | «ZENBET»',
      title: 'নতুন',
      titleSpan: 'গ্রাহকদের জন্য',
      promoSpan: 'প্রোমো কোড:',
      btnGet: 'পান',
      bkString: 'বুকমেকার «ZENBET»',
      rightString: 'সর্বস্বত্ব সংরক্ষিত',
      rulesBtn: 'শর্তাবলী',
      regFormTitle: `Register
        and get the bonus!`
    },
    br: {
      siteTitle30: 'Um bônus de BRL 2.300,00 | «ZENBET»',
      siteTitle35: 'Bônus de boas-vindas | «ZENBET»',
      title: 'Para novos',
      titleSpan: 'CLIENTES',
      promoSpan: 'CÓDIGO PROMOCIONAL:',
      btnGet: 'receber',
      bkString: 'Bookmaker «ZENBET»',
      rightString: 'Todos os direitos reservados',
      rulesBtn: 'regras',
      regFormTitle: `REGISTRE-SE
        E OBTENHA UM BÔNUS!`
    },
    de: {
      siteTitle: 'Ihre Boni | Zenit',
      title: 'FÜR NEUE',
      titleSpan: 'KUNDEN',
      promoSpan: 'PROMO CODE:',
      btnGet: 'Jetzt erhalten',
      bkString: 'BUCHMACHER «ZENBET»',
      rightString: 'ALLE RECHTE VORBEHALTEN',
      rulesBtn: 'Regeln',
      regFormTitle: `Register
        and get the bonus!`
    },
    en: {
      siteTitle30: 'Bonus 400 $ | «ZENBET»',
      siteTitle35: 'Bonus 430 $ | «ZENBET»',
      title: 'FOR NEW',
      titleSpan: 'CUSTOMERS',
      promoSpan: 'PROMO CODE:',
      btnGet: 'receive',
      bkString: 'BOOKMAKER «ZENBET»',
      rightString: 'ALL RIGHTS RESERVED',
      rulesBtn: 'rules',
      regFormTitle: `Register
        and get the bonus!`
    },
    fr: {
      siteTitle: 'Vos bonus | «ZENBET»',
      title: 'POUR LES NOUVEAUX',
      titleSpan: 'CLIENTS',
      promoSpan: 'CODE PROMOTIONNEL:',
      btnGet: 'OBTENIR',
      bkString: 'Bookmaker «ZENBET»',
      rightString: 'Tous droits réservés',
      rulesBtn: 'Conditions générales',
      regFormTitle: `Register
        and get the bonus!`
    },
    ir: {
      siteTitle: 'پاداش خوش‌آمدگویی | «ZENBET»',
      title: 'برای مشتریان',
      titleSpan: 'جدید',
      promoSpan: 'کد هدیه:',
      btnGet: 'دریافت',
      bkString: ' بنگاه شرط‌بندی «ZENBET»',
      rightString: 'تمامی حقوق محفوظ است',
      rulesBtn: 'قوانین',
      regFormTitle: `Register
        and get the bonus!`
    },
    kz: {
      siteTitle: 'Сенің бонустарың | «ZENBET»',
      title: 'новым',
      titleSpan: 'игрокам',
      promoSpan: 'промокод:',
      btnGet: 'получить',
      bkString: 'Букмекерская контора «ZENBET»',
      rightString: 'Все права защищены',
      rulesBtn: 'правила',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    mx: {
      siteTitle: 'Sus bonificaciones | «ZENBET»',
      title: 'PARA NUEVOS',
      titleSpan: 'CLIENTES',
      promoSpan: 'CÓDIGO PROMOCIONAL:',
      btnGet: 'OBTENER',
      bkString: '«ZENBET» Bookmakers',
      rightString: 'Todos los derechos reservados',
      rulesBtn: 'TÉRMINOS Y CONDICIONES',
      regFormTitle: `Register
        and get the bonus!`
    },
    ru: {
      siteTitle: 'Твои бонусы | «ZENBET»',
      title: 'новым',
      titleSpan: 'игрокам',
      promoSpan: 'промокод:',
      btnGet: 'получить',
      bkString: 'Букмекерская контора «ZENBET»',
      rightString: 'Все права защищены',
      rulesBtn: 'правила'
    },
    sw: {
      siteTitle: 'Bonasi zako | «ZENBET»',
      title: `KWA AJILI`,
      titleSpan: `YA\xA0WATEJA WAPYA`,
      promoSpan: 'MSIMBO WA PROMOSHENI:',
      btnGet: 'PATA',
      bkString: 'Alamisho «ZENBET»',
      rightString: 'Haki zote zimehifadhiwa',
      rulesBtn: `SHERIA NA\xA0MASHARTI`,
      regFormTitle: `Register
        and get the bonus!`
    },
    tr: {
      siteTitle: 'Bonuslarınız | «ZENBET»',
      title: 'YENI',
      titleSpan: 'MÜŞTERİLER İÇİN',
      promoSpan: 'PROMOSYON KODU:',
      btnGet: 'AL',
      bkString: 'Zenit Bahis Şirketi',
      rightString: 'Tüm hakları saklıdır',
      rulesBtn: 'HÜKÜM VE KOŞULLAR',
      regFormTitle: `Register
        and get the bonus!`
    },
    ua: {
      siteTitle: 'Твои бонусы | «ZENBET»',
      title: 'новим',
      titleSpan: 'гравцям',
      promoSpan: 'промокод:',
      btnGet: 'отримати',
      bkString: 'БУКМЕКЕРСЬКА КОНТОРА «ZENBET»',
      rightString: 'ВСI ПРАВА ЗАХИЩЕНI',
      rulesBtn: 'правила',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    uz: {
      siteTitle: 'Bonuslaring | «ZENBET»',
      title: 'YANGI',
      titleSpan: 'O‘YINCHILARGA',
      promoSpan: 'PROMOKOD:',
      btnGet: 'OLISH',
      bkString: '«ZENBET» bukmekerlik kontorasi',
      rightString: 'Barcha huquqlar himoya qilinadi',
      rulesBtn: 'QOIDALAR',
      regFormTitle: `Зарегистрируйся
        и получи бонус!`
    },
    vi: {
      siteTitle: 'Tiền thưởng của bạn | «ZENBET»',
      title: 'DÀNH CHO',
      titleSpan: 'KHÁCH HÀNG MỚI',
      promoSpan: 'MÃ KHUYẾN MÃI:',
      btnGet: 'NHẬN',
      bkString: 'Nhà cái «ZENBET»',
      rightString: 'Bảo lưu mọi quyền',
      rulesBtn: `Điều khoản và\xA0điều\xA0kiện`,
      regFormTitle: `Register
        and get the bonus!`
    }
  }
}